import * as React from 'react';
import { mergeStyles } from '@cian/utils';

import { validateImage } from './utils/validateImage';
import { DefaultImg } from './DefaultImg';

import * as styles from './styles.css';

interface IProps {
  className?: string;
  src?: string | null;
  width?: number;
  height?: number;
}

// tslint:disable-next-line:variable-name
export const _PreviewImg: React.FC<IProps> = props => {
  const [isError, setErrorValue] = React.useState<boolean>(false);
  const [url, setUrl] = React.useState<string | null>(null);
  const setError = () => setErrorValue(true);

  React.useEffect(() => {
    if (!props.src) {
      setError();
    } else {
      validateImage(props.src)
        .then(() => {
          setUrl(props.src as string);
        })
        .catch(() => {
          setError();
        });
    }
  }, []);

  if (isError || !url) {
    return <DefaultImg {...mergeStyles(styles['img'], props.className)} width={props.width} height={props.height} />;
  }

  return (
    <div
      {...mergeStyles(styles['img'], props.className, {
        backgroundImage: `url("${url}")`,
        width: props.width,
        height: props.height,
      })}
    />
  );
};

export const PreviewImg = React.memo(_PreviewImg);

PreviewImg.displayName = 'PreviewImg';
